import { useEffect } from "react";
import { usePostHog } from "posthog-js/react";
import { useUser } from "./useUser";

export function usePostHogIdentify() {
  const posthog = usePostHog();
  const { data: user } = useUser();

  useEffect(() => {
    // uuid only: names never go to PostHog (Dova Metrics & KPIs §7).
    if (user?.uuid && posthog) {
      posthog.identify(user.uuid);
    }
  }, [user?.uuid, posthog]);
}
